module.exports = __webpack_public_path__ + "img/numCard.49abf89f.svg";